<template>
  <div class="content">
    <el-row :gutter="12">
      <el-col :span="12" class="fix__top">
        <el-input
          class="style-fullWidth"
          v-model="search"
          size="medium"
          placeholder="Tìm kiếm"
          prefix-icon="el-icon-search"
          @keydown.enter.exact.native="searchTree"
        ></el-input>
      </el-col>
    </el-row>

    <hashtag-common
      @selectTags="selectTags"
      :groupTypeId="GROUPS.GROUP_TYPE_ID.CA_NHAN"
    />

    <VuePerfectScrollbar
      class="scroll-scope listCompanies"
      :settings="settings"
    >
      <el-tree
        :data="roots"
        :filter-node-method="filterTree"
        ref="departmentTree"
        class="filter-tree"
        default-expand-all
      >
        <div
          class="custom-tree-node flex-row flex__between width__100"
          slot-scope="{ node, data }"
        >
          <div class="field-1" @click.native.stop="() => false">
            <span>
              <el-checkbox
                v-model="data.checked"
                @change="checkedChange(data)"
              ></el-checkbox>
              <span
                v-if="
                  data.nodeType === DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE
                "
              >
                &nbsp;
                <span class="font-weight__bold">
                  {{ data.userDeptRole.fullName }}
                </span>
                <span class="font-size__small font-italic">
                  ({{ data.userDeptRole.positionName }})
                </span>
              </span>
              <span v-else>&nbsp;{{ getNodeLabel(data) }}</span>
            </span>
          </div>
        </div>
      </el-tree>
    </VuePerfectScrollbar>
  </div>
</template>

<script>
  import constants from "../../../constants";
  import utils from "../../../services/utils";
  import h from "../../../services/h";
  import handlersTreeMixin from "../../../mixins/handlersTreeMixin";
  import VuePerfectScrollbar from "vue-perfect-scrollbar";
  import HashtagCommon from "../../doc-in/components/chuyenXuLy-hashtag";

  export default {
    name: "banhanh-cc-tree",
    mixins: [handlersTreeMixin],
    components: {
      HashtagCommon,
      VuePerfectScrollbar
    },
    props: ["selectedHandlerIds"],
    data() {
      return {
        DEPARTMENT_TREE: constants.DEPARTMENT_TREE,
        DEPARTMENT: constants.DEPARTMENT,
        GROUPS: constants.GROUPS,
        search: null,
        settings: {maxScrollbarLength: 750}
      };
    },

    methods: {
      setUserDeptRoleHandlers(userDeptRoleHandlers) {
        this.userDeptRoleHandlers = userDeptRoleHandlers;
        return this.buildNodes();
      },

      markCheckedForSelectedToUsers(selectedToUserIds) {
        if (selectedToUserIds && selectedToUserIds.length) {
          h.each(this.roots, root =>
            this.markChecked_(
              root,
              data =>
                data.nodeType ===
                constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE &&
                selectedToUserIds.indexOf(data.userDeptRole.id) !== -1
            )
          );
        }
      },

      searchTree() {
        this.$refs.departmentTree.filter(this.search);
      },

      selectTags(event) {
        let selectedTagData = event;
        h.each(this.roots, root =>
          this.markChecked_(root, data => {
            h.exists(
              selectedTagData,
              item =>
                (item.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.DEPT &&
                  data.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.DEPT &&
                  data.department.id === item.department.id) ||
                (item.nodeType ===
                  constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE &&
                  data.nodeType ===
                  constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE &&
                  data.userDeptRole.id === item.handler.id)
            );
          })
        );
      },

      filterTree(value, data) {
        switch (data.nodeType) {
          case constants.DEPARTMENT_TREE.NODE_TYPE.DEPT:
            return utils.like(data.department.deptName, this.search);
          case constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE:
            return utils.isUserDeptRoleMatchWithQuery(
              data.userDeptRole,
              this.search
            );
          default:
            return false;
        }
      },

      checkedAllChildren(data, checked) {
        h.each(data.children, child => {
          let checkedState = child.checked || false;
          if (checkedState !== checked) {
            this.$set(child, "checked", checked);
            if (
              data.nodeType !== constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE
            )
              this.checkedAllChildren(child, checked);
          }
        });
      },

      updateCheckedForParent(data) {
        let parent = data.parent;
        if (!parent || parent.isHandlerNode) return;
        let currentCheckedState = parent.checked;
        let newCheckedState = !h.exists(parent.children, child => !child.checked);
        if (currentCheckedState !== newCheckedState) {
          this.$set(parent, "checked", newCheckedState);
          this.updateCheckedForParent(parent);
        }
      },

      markChecked_(data, isShouldCheckFn) {
        if (!data.checked) {
          let shouldCheck = isShouldCheckFn(data);
          if (shouldCheck) {
            this.$set(data, "checked", true);
            if (
              data.nodeType !== constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE
            )
              this.checkedAllChildren(data, data.checked);
          } else {
            h.each(data.children, child =>
              this.markChecked_(child, isShouldCheckFn)
            );
            if (
              data.nodeType !== constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE
            ) {
              if (!h.exists(data.children, child => !child.checked))
                this.$set(data, "checked", true);
            }
          }
        }
      },

      getNodeLabel(node) {
        let nodeType = node.nodeType;
        switch (nodeType) {
          case this.DEPARTMENT_TREE.NODE_TYPE.DEPT:
            return node.department.deptName || "-";
          case this.DEPARTMENT_TREE.NODE_TYPE.BTGD:
            return "Ban Tổng giám đốc";
          case this.DEPARTMENT_TREE.NODE_TYPE.HDTV:
            return "Hội đồng thành viên";
          case this.DEPARTMENT_TREE.NODE_TYPE.DVTT:
            return "Đơn vị trực thuộc";
          case this.DEPARTMENT_TREE.NODE_TYPE.PBCN:
            return "Phòng ban chức năng";
          case this.DEPARTMENT_TREE.NODE_TYPE.PBCNAndDVTT:
            return "Phòng ban CN & Đơn vị TT";
          default:
            return "-";
        }
      },

      checkedChange(data) {
        if (data.nodeType !== constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE)
          this.checkedAllChildren(data, data.checked);
        this.updateCheckedForParent(data);
      },

      getToHandlers() {
        let toHandlers = [];
        let queue = [];
        queue.push(...this.roots);
        let index = 0;
        while (index < queue.length) {
          let data = queue[index];
          if (
            data.isHandlerNode &&
            data.nodeType ===
            constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE &&
            data.checked
          )
            toHandlers.push(data.userDeptRole);
          queue.push(...(data.children || []));
          index++;
        }
        return toHandlers;
      }
    }
  };
</script>

<style scoped>
  .select-Unit-BanHanh .content {
    padding: 10px 15px;
    padding-bottom: 0;
    border: 1px solid #ceced2;
    border-radius: 4px;
  }

  .select-Unit-BanHanh .label {
    color: #2d3e4f;
    font-size: 12px;
    line-height: 20px;
    margin-bottom: 10px;
    margin-top: 7px;
  }

  .select-Unit-BanHanh .content .listCompanies.scroll-scope {
    margin-top: 5px;
    max-height: calc(100vh - 250px);
    position: relative;
    margin-bottom: 10px;
    width: 100%;
  }

  .select-Unit-BanHanh .content .listCompanies .company_item {
    margin: 10px 0;
  }

  .select-Unit-BanHanh .content .listCompanies .company_item .name {
    color: #2d3e4f;
    font-weight: 700;
  }

  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-right: 25px;
  }

  .tag_select {
    box-shadow: 0px 0.5px 1.5px rgb(0, 0, 0, 0.05);
    transition: all 0.25s;
  }

  .tag_select:hover {
    transform: translateY(2px);
    text-decoration: underline;
    transition: 0.15s;
    box-shadow: none;
  }
</style>



// WEBPACK FOOTER //
// src/views/doc-out/components/banhanh-cc-tree.vue